/**
 * The rules, already parsed, for an app that wants to render them.
 *
 * The only thing in this package that needs a bundler: `?raw` is Vite's (and
 * webpack's, as an asset module) way of importing a file as a string. It is
 * one line of coupling, deliberately isolated in one file, and the alternative
 * was worse in the specific way this whole exercise is about.
 *
 * The alternative was a build step writing `rules.json`. That is a *generated
 * copy of a governance document*, and a generated copy is stale the moment
 * somebody edits the README without running the generator — which is exactly
 * the failure the reader app hit in LO-15 with a hardcoded collection map,
 * and exactly what `docs.py` refuses to do on the Python side. `?raw` reads
 * the real file at build time and cannot disagree with it.
 *
 * An app that cannot use `?raw` imports `@lopie/kernel-ui/rules` and hands it
 * markdown from wherever it can get markdown.
 */

import readme from "../README.md?raw";
import { parseRules, summarise } from "./rules.js";

/** Where the text came from. Named, because a screen showing rules should be
 * able to say which file it read them out of — and it is the same string the
 * MCP's `design_rules` returns for the same reason. */
export const SOURCE = "packages/kernel-ui/README.md";

export const README = readme;

export const RULES = parseRules(readme);

export const SUMMARY = summarise(RULES);

export { CATEGORIES, ORDER, parseRules, parseEnforcement, summarise } from "./rules.js";
